import { render, staticRenderFns } from "./PracticeCardNew.vue?vue&type=template&id=5a068bfa"
import script from "./PracticeCardNew.vue?vue&type=script&lang=js"
export * from "./PracticeCardNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports